export const getRow = (number, lang = 'tr') => {
    const rows = row["row" + number];
    if (lang === 'tr') return rows;

    return rows?.map((item) => ({
        ...item,
        title: titleMap[item.title] ?? item.title,
        content: contentMap[item.content] ?? item.content
    }));
}

const titleMap = {
    "Yüklenme Sayfası": "Loading Page",
    "Giriş Sayfası": "Login Page",
    "Ücretsiz İnternet Paketleri": "Complimentary internet packages",
    "Miles&Smiles üyesi ol": "Miles&Smiles Application Form",
    "Ücretli İnternet Paketleri": "Paid Internet Packages",
    "Bizi Değerlendirin": "Rate Us",
    "Uçuş bilgileri Giriş Yöntemi": "Flight Details Login Method",
    "Mobil Uygulama Giriş Yöntemi": "Mobile App Login Method",
    "Miles&Smiles Giriş Yöntemi": "Miles&Smiles Login Method",
    "Kota Gösterim Sayfası": "Remaining Quota Page",
    "iPhone - Düşük Veri Modu": "iPhone - Low Data Mode",
    "Android - Düşük Veri Modu": "Android - Low Data Mode",
    "Macbook - Düşük Veri Modu": "MacBook - Low Data Mode",
    "Windows - Düşük Veri Modu": "Windows - Low Data Mode",
    "Bilet numarası Giriş Yöntemi": "Ticket Number Login Method",
    "Üyelik numarası Giriş Yöntemi": "Membership Number Login Method",
    "Portal Dil Değişikliği": "Portal Language Change",
    "E-Posta adresi Giriş Yöntemi": "Email Address Login Method",
    "Paket Satın Alma Sayfası": "Package Purchase Page",
    "Ödeme Sayfası": "Payment Page",
    "Başarılı Satın Alma İşlemi": "Successful Purchase",
    "Mil ile öde": "Pay with Miles",
    "Bağlantıyı Durdur": "Stop Connection",
    "Bağlantıyı Devam Ettir": "Resume Connection",
    "Sıkça Sorulan Sorular": "Frequently Asked Questions",
    "Simülasyonu Tamamla": "Complete Simulation",
    "Çıkış Yap": "Log Out"
};

const contentMap = {
    "İlk giriş ekranı bağlantılar sağlandığı zaman otomatik olarak geçecektir.": "The first login screen will proceed automatically when connection is available.",
    "Bu ekrandan <b>'Ücretsiz İnternet Paketleri'</b> sayfasına gidiniz.": "From this screen, go to the <b>'Complimentary internet packages'</b> page.",
    "Yukarıda bulunan <b>'Geri dön'</b> butonundan login sayfasına dönün.": "Use the <b>'Go back'</b> button above to return to the login page.",
    "Sayfanın altındaki <b>'Ana sayfaya dön'</b> butonundan Giriş sayfasına ilerleyin.": "Use the <b>'Back to home page'</b> button at the bottom to go to the Login page.",
    "Sayfadaki <b>'Miles&Smiles üyesi ol'</b> butonundan Miles&smiles üyelik sayfasına ilerleyin.": "Use the <b>'Join Miles&Smiles'</b> button to navigate to the membership page.",
    "Bu ekrandan <b>'Ücretli İnternet Paketleri'</b> sayfasına gidiniz.": "From this screen, go to the <b>'Paid internet packages'</b> page.",
    "<b>'Bizi değerlendirin'</b> sayfasına gidiniz.": "Go to the <b>'Rate us'</b> page.",
    "Bu ekrandan <b>'Geri dön'</b> butonunu kullanarak giriş sayfasına gidiniz.": "Use the <b>'Go back'</b> button on this screen to return to the login page.",
    "Giriş yöntemlerinden <b>'Miles&Smiles'</b> sekmesine tıklayın.": "From login methods, click the <b>'Miles&Smiles'</b> tab.",
    "Koltuk Numarası: <b>1A</b><br/>Soyad: <b>AHMAD</b><br/>bilgileri ile giriş yapın.": "Log in with <br/>Seat Number: <b>1A</b><br/>Surname: <b>AHMAD</b>.",
    "Giriş yöntemlerinden <b>'Uçuş bilgileri'</b> sekmesine tıklayın.": "From login methods, click the <b>'Flight details'</b> tab.",
    "Giriş yöntemlerinden <b>'Mobil Uygulama'</b> sekmesine tıklayın.": "From login methods, click the <b>'Mobile App'</b> tab.",
    "<b>'Nasıl yapabilirim?'</b> butonu ile devam ediniz.": "Continue with the <b>'How can I do it?'</b> button.",
    "<b>'Sağ Ok'</b> yardımıyla slayt içeriğini değiştirin.": "Use the <b>'Right Arrow'</b> to change the slide content.",
    "Tekrar <b>'Sağ Ok'</b> yardımıyla slayt içeriğini değiştirin.": "Use the <b>'Right Arrow'</b> again to change the slide content.",
    "<b>'Cihaz'</b> kısmından <b>'Windows'</b> seçiniz.": "Select <b>'Windows'</b> from the <b>'Device'</b> section.",
    "<b>'Cihaz'</b> kısmından <b>'Android'</b> seçiniz.": "Select <b>'Android'</b> from the <b>'Device'</b> section.",
    "<b>'Cihaz'</b> kısmından <b>'Macbook'</b> seçiniz.": "Select <b>'Macbook'</b> from the <b>'Device'</b> section.",
    "<b>'Anladım'</b> butonu ile bilgilendirme ekranını kapatın.": "Close the information screen with the <b>'I understand'</b> button.",
    "<b>'Çıkış yap'</b> butonu ile giriş sayfasına geçiniz.": "Go to the login page using the <b>'Logout'</b> button.",
    "Giriş yöntemlerinden <b>'Bilet numarası'</b> sekmesine tıklayın.": "From login methods, click the <b>'Ticket number'</b> tab.",
    "Bilet Numarası: <b>1234567890123</b><br/>bilgileri ile giriş yapınız.": "Log in with Ticket Number: <b>1234567890123</b>.",
    "M&S üyelik numarası: <b>TK123456789</b><br/>Şifre: <b>111111</b><br/>bilgileri ile giriş yapınız.": "Log in with M&S membership number: <b>TK123456789</b><br/>Password: <b>111111</b>.",
    "Giriş yöntemlerinden <b>'E-posta adresi'</b> sekmesine tıklayın.": "From login methods, click the <b>'Email address'</b> tab.",
    "Portalın dilini anlayacağınız bir dile <b>TEKRAR</b> çeviriniz.": "Change the portal language back to a language you understand <b>AGAIN</b>.",
    "Sağ üst köşede <b>'TR' veya 'EN'</b> yazan butona tıklayınız. Portalın dilini istediğiniz bir dile çeviriniz.": "Click the <b>'TR' or 'EN'</b> button at the top right. Change the portal language to any language you want.",
    "E-Posta: <b>deneme@test.com</b><br/>Şifre: <b>111111</b><br/>bilgileri ile giriş yapınız.": "Log in with <br/>Email: <b>deneme@test.com</b><br/>Password: <b>111111</b>.",
    "<b>'Paket satın al'</b> butonu ile sonraki sayfaya geçiniz.": "Go to the next page using the <b>'Purchase a package'</b> button.",
    "Herhangi bir paket seçiniz.": "Select any package.",
    "Ödeme yöntemlerinden <b>'Mil ile öde'</b> sekmesine geçiniz.": "In payment methods, switch to the <b>'Pay with Miles'</b> tab.",
    "Sayfada bulunan <b>'Bağlantıyı durdur'</b> butonundan internet çıkışını durdurun.": "Stop internet access using the <b>'Pause connection'</b> button on the page.",
    "Sayfadaki <b>'Kalan kotayı gör'</b> butonundan kota gösterim sayfasına ilerleyin.": "Use the <b>'View remaining quota'</b> button to go to the remaining quota page.",
    "Satın alma işlemi yapınız.": "Complete the purchase.",
    "<b>'Bağlantıyı devam ettir'</b> butonunu kullanarak internet kullanımına devam edin.": "Continue internet usage using the <b>'Continue connection'</b> button.",
    "Sayfanın en altında bulunan <b>'Sıkça sorulan sorular'</b> kısmına ilerleyin.": "Go to the <b>'Frequently asked questions'</b> section at the bottom of the page.",
    "Sayfada bulunan <b>'Geri Dön'</b> butonuyla bir önceki sayfaya gidiniz.": "Use the <b>'Go back'</b> button on the page to return to the previous page.",
    "Lütfen bekleyiniz.": "Please wait.",
    "Simülasyon Tamamlandı": "Simulation Completed",
    "Sayfadaki <b>'Çıkış yap'</b> butonunu kullanarak çıkış yapınız.": "Use the <b>'Logout'</b> button on the page to log out."
};

const row = {
    row1: [
        {
            id: 1,
            title: "Yüklenme Sayfası",
            content: "İlk giriş ekranı bağlantılar sağlandığı zaman otomatik olarak geçecektir."
        },
        {
            id: 2,
            title: "Giriş Sayfası",
            content: "Bu ekrandan <b>'Ücretsiz İnternet Paketleri'</b> sayfasına gidiniz."
        },
        {
            id: 3,
            title: "Ücretsiz İnternet Paketleri",
            content: "Yukarıda bulunan <b>'Geri dön'</b> butonundan login sayfasına dönün."
        }
    ],
    row2: [
        {
            id: 6,
            title: "Miles&Smiles üyesi ol",
            content: "Sayfanın altındaki <b>'Ana sayfaya dön'</b> butonundan Giriş sayfasına ilerleyin."
        },
        {
            id: 5,
            title: "Ücretli İnternet Paketleri",
            content: "Sayfadaki <b>'Miles&Smiles üyesi ol'</b> butonundan Miles&smiles üyelik sayfasına ilerleyin."
        },
        {
            id: 4,
            title: "Giriş Sayfası",
            content: "Bu ekrandan <b>'Ücretli İnternet Paketleri'</b> sayfasına gidiniz."
        }
    ],
    row3: [
        {
            id: 7,
            title: "Giriş Sayfası",
            content: "<b>'Bizi değerlendirin'</b> sayfasına gidiniz."
        },
        {
            id: 8,
            title: "Bizi Değerlendirin",
            content: "Bu ekrandan <b>'Geri dön'</b> butonunu kullanarak giriş sayfasına gidiniz."
        },
        {
            id: 9,
            title: "Giriş Sayfası",
            content: "Giriş yöntemlerinden <b>'Miles&Smiles'</b> sekmesine tıklayın."
        }
    ],
    row4: [
        {
            id: 12,
            title: "Uçuş bilgileri Giriş Yöntemi",
            content: "Koltuk Numarası: <b>1A</b><br/>Soyad: <b>AHMAD</b><br/>bilgileri ile giriş yapın."
        },
        {
            id: 11,
            title: "Mobil Uygulama Giriş Yöntemi",
            content: "Giriş yöntemlerinden <b>'Uçuş bilgileri'</b> sekmesine tıklayın."
        },
        {
            id: 10,
            title: "Miles&Smiles Giriş Yöntemi",
            content: "Giriş yöntemlerinden <b>'Mobil Uygulama'</b> sekmesine tıklayın."
        }
    ],

    row5: [
        {
            id: 1,
            title: "Kota Gösterim Sayfası",
            content: "<b>'Nasıl yapabilirim?'</b> butonu ile devam ediniz."
        },
        {
            id: 2,
            title: "iPhone - Düşük Veri Modu",
            content: "<b>'Sağ Ok'</b> yardımıyla slayt içeriğini değiştirin."
        },
        {
            id: 3,
            title: "iPhone - Düşük Veri Modu",
            content: "Tekrar <b>'Sağ Ok'</b> yardımıyla slayt içeriğini değiştirin."
        }
    ],
    row6: [
        {
            id: 6,
            title: "Android - Düşük Veri Modu",
            content: "<b>'Cihaz'</b> kısmından <b>'Windows'</b> seçiniz."
        },
        {
            id: 5,
            title: "Macbook - Düşük Veri Modu",
            content: "<b>'Cihaz'</b> kısmından <b>'Android'</b> seçiniz."
        },
        {
            id: 4,
            title: "iPhone - Düşük Veri Modu",
            content: "<b>'Cihaz'</b> kısmından <b>'Macbook'</b> seçiniz."
        }
    ],
    row7: [
        {
            id: 7,
            title: "Windows - Düşük Veri Modu",
            content: "<b>'Anladım'</b> butonu ile bilgilendirme ekranını kapatın."
        },
        {
            id: 8,
            title: "",
            content: "<b>'Cihaz'</b> kısmından <b>'Windows'</b> seçiniz."
        },
        {
            id: 9,
            title: "",
            content: "<b>'Cihaz'</b> kısmından <b>'Macbook'</b> seçiniz."
        }
    ],
    row8: [
        {
            id: 12,
            title: "",
            content: ""
        },
        {
            id: 11,
            title: "",
            content: ""
        },
        {
            id: 10,
            title: "",
            content: ""
        }
    ],

    row9: [
        {
            id: 1,
            title: "Kota Gösterim Sayfası",
            content: "<b>'Çıkış yap'</b> butonu ile giriş sayfasına geçiniz."
        },
        {
            id: 2,
            title: "Giriş Sayfası",
            content: "Giriş yöntemlerinden <b>'Bilet numarası'</b> sekmesine tıklayın."
        },
        {
            id: 3,
            title: "Bilet numarası Giriş Yöntemi",
            content: "Bilet Numarası: <b>1234567890123</b><br/>bilgileri ile giriş yapınız."
        }
    ],
    row10: [
        {
            id: 6,
            title: "Üyelik numarası Giriş Yöntemi",
            content: "M&S üyelik numarası: <b>TK123456789</b><br/>Şifre: <b>111111</b><br/>bilgileri ile giriş yapınız."
        },
        {
            id: 5,
            title: "Giriş Sayfası",
            content: "Giriş yöntemlerinden <b>'Miles&Smiles'</b> sekmesine tıklayın."
        },
        {
            id: 4,
            title: "Kota Gösterim Sayfası",
            content: "<b>'Çıkış yap'</b> butonu ile giriş sayfasına geçiniz."
        }
    ],
    row11: [
        {
            id: 7,
            title: "Kota Gösterim Sayfası",
            content: "<b>'Çıkış yap'</b> butonu ile giriş sayfasına geçiniz."
        }
        ,
        {
            id: 8,
            title: "Giriş Sayfası",
            content: "Giriş yöntemlerinden <b>'Miles&Smiles'</b> sekmesine tıklayın."
        },
        {
            id: 9,
            title: "Miles&Smiles Giriş Yöntemi",
            content: "Giriş yöntemlerinden <b>'E-posta adresi'</b> sekmesine tıklayın."
        }
    ],
    row12: [
        {
            id: 12,
            title: "Portal Dil Değişikliği",
            content: "Portalın dilini anlayacağınız bir dile <b>TEKRAR</b> çeviriniz."
        },
        {
            id: 11,
            title: "Kota Gösterim Sayfası",
            content: "Sağ üst köşede <b>'TR' veya 'EN'</b> yazan butona tıklayınız. Portalın dilini istediğiniz bir dile çeviriniz."
        },
        {
            id: 10,
            title: "E-Posta adresi Giriş Yöntemi",
            content: "E-Posta: <b>deneme@test.com</b><br/>Şifre: <b>111111</b><br/>bilgileri ile giriş yapınız."
        }
    ],
//---
    row13: [
        {
            id: 1,
            title: "Kota Gösterim Sayfası",
            content: "<b>'Paket satın al'</b> butonu ile sonraki sayfaya geçiniz."
        },
        {
            id: 2,
            title: "Paket Satın Alma Sayfası",
            content: "Herhangi bir paket seçiniz."
        },
        {
            id: 3,
            title: "Ödeme Sayfası",
            content: "Ödeme yöntemlerinden <b>'Mil ile öde'</b> sekmesine geçiniz."
        }
    ],
    row14: [
        {
            id: 6,
            title: "Kota Gösterim Sayfası",
            content: "Sayfada bulunan <b>'Bağlantıyı durdur'</b> butonundan internet çıkışını durdurun."
        },
        {
            id: 5,
            title: "Başarılı Satın Alma İşlemi",
            content: "Sayfadaki <b>'Kalan kotayı gör'</b> butonundan kota gösterim sayfasına ilerleyin."
        },
        {
            id: 4,
            title: "Mil ile öde",
            content: "Satın alma işlemi yapınız."
        }
    ],
    row15: [
        {
            id: 7,
            title: "Bağlantıyı Durdur",
            content: "<b>'Bağlantıyı devam ettir'</b> butonunu kullanarak internet kullanımına devam edin."
        },
        {
            id: 8,
            title: "Bağlantıyı Devam Ettir",
            content: "Sayfanın en altında bulunan <b>'Sıkça sorulan sorular'</b> kısmına ilerleyin."
        },
        {
            id: 9,
            title: "Sıkça Sorulan Sorular",
            content: "Sayfada bulunan <b>'Geri Dön'</b> butonuyla bir önceki sayfaya gidiniz."
        }
    ],
    row16: [
        {
            id: 11,
            title: "Simülasyonu Tamamla",
            content: "Lütfen bekleyiniz."
        },
        {
            id: 11,
            title: "Çıkış Yap",
            content: "Simülasyon Tamamlandı"
        },
        {
            id: 10,
            title: "Kota Gösterim Sayfası",
            content: "Sayfadaki <b>'Çıkış yap'</b> butonunu kullanarak çıkış yapınız."

        }
    ]
}
